import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCellProps } from '@progress/kendo-react-grid';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { isButtonEnabled } from 'src/components/design-system/Button';
import DropDown from 'src/components/design-system/DropDown';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import { getBgColor } from 'src/utils/icons';

const GLCodeDropDownCell = (props: GridCellProps) => {
  const { glCodeOptions } = useReceiptDetails();
  const { dataItem, field = '' } = props;

  const handleChange = (e: DropDownListChangeEvent) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: props.dataIndex,
        dataItem: props.dataItem,
        field: 'poglCode',
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };
  const errors = useMemo(() => dataItem.errors?.poglCode, [dataItem.errors?.poglCode]);
  const warnings = useMemo(() => dataItem.warnings?.poglCode, [dataItem.warnings?.poglCode]);
  let dataValue = dataItem[field];
  let value = glCodeOptions.find((glCodeData) => glCodeData?.value === dataItem.poglCode);

  return (
    <GridCellBase {...props} title={value?.label} className={getBgColor(errors, warnings)}>
      {isButtonEnabled(dataItem?.canDeleteReceiptLineItem) ? (
        <DropDown
          onChange={handleChange}
          value={value?.value}
          valid={!warnings?.length && !errors?.length}
          options={glCodeOptions as any}
        />
      ) : (
        dataValue
      )}
    </GridCellBase>
  );
};

export default GLCodeDropDownCell;
